// utils/auth.js
export const isAuthenticated = () => {
    // Adjust the logic as per your token storage (localStorage, sessionStorage, cookies, etc.)
    return !!localStorage.getItem('_crm__token');
};
